import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { EditedImageResult } from './upload-edited-image.types';

@Component({
  selector: 'app-upload-edited-image',
  templateUrl: './upload-edited-image.component.html',
  styleUrl: './upload-edited-image.component.scss',
})
export class UploadEditedImageComponent {
  @Input()
  public uploadProgress: number = 0;
  

  @Input()
  public topText: string = '';

  @Output()
  public clicked: EventEmitter<boolean> = new EventEmitter();

  constructor(
    public commonService: CommonService,
    private currentlyActiveModal: NgbActiveModal,
  ) {}


  @Input()
  public set initialImage(s: string  | ArrayBuffer )
  {
    this.convertedImageToShow = s;
    this.initCropper();
  }
  public convertedImageToShow: string | ArrayBuffer = null;

  @Input()
  public imageToUpload: File = null;

  @Input()
  public currentUploadCaption = '';

  @Input()
  public set cropInformation(info: string){
    try{
       this.currentCropInformationToBeSaved = JSON.parse(info);
    }catch(e){
      this.currentCropInformationToBeSaved = {};
      console.error(e)
    }
  }

  public readonly cameraUploadId = 'camera-upload';

  public readonly fileUploadId = 'fileupload';

  public signalUploadImage() {
    const results: EditedImageResult =  
    {cropInformation: this.currentCropInformationToBeSaved, caption: this.currentUploadCaption, imageData: this.imageToUpload}
    this.currentlyActiveModal.close(results);
  }

  public uploadImageChanged(event) {
    const { target } = event;
    const file = target.files[0];

    this.imageToUpload = file;

    const fileReader = new FileReader();
    fileReader.onload = () => {
      this.convertedImageToShow = fileReader.result;
      this.initCropper();
    };
    fileReader.readAsDataURL(this.imageToUpload);
  }

  public imageToBeCropped: string = '';
  private cropperMovesInXAxis: boolean = false;
  private isDraggingCropper: boolean = false;
  private cropperSquareElement = null;

  private cropperMinX = -1;
  private cropperMinY = -1;
  private cropperMaxX = -1;
  private cropperMaxY = -1;

  private currentCropperX = 0;
  private currentCropperY = 0;

  private imageWidth = 0;
  private imageHeight = 0;

  private initialX = -1;
  private initialY = -1;

  public cropperDragStart(event) {
    console.log('drag started');
    this.isDraggingCropper = true;
    this.initialX = event.clientX - this.cropperSquareElement.offsetLeft;
    this.initialY = event.clientY - this.cropperSquareElement.offsetTop;
  }

  public cropperDragContinue(event) {
    console.log('drag moving');
    if (this.isDraggingCropper) {
      let newX = event.clientX - this.initialX;
      let newY = event.clientY - this.initialY;

      if (this.cropperMovesInXAxis) {
        //lock check
        if (newX > this.cropperMaxX) {
          newX = this.cropperMaxX;
        } else if (newX < this.cropperMinX) {
          newX = this.cropperMinX;
        }

        this.cropperSquareElement.style.left = `${newX}px`;
        this.currentCropperX = newX;
      } else if (!this.cropperMovesInXAxis) {
        if (newY > this.cropperMaxY) {
          newY = this.cropperMaxY;
        } else if (newY < this.cropperMinY) {
          newY = this.cropperMinY;
        }

        this.cropperSquareElement.style.top = `${newY}px`;
        this.currentCropperY = newY;
      }
    }
  }

  public cropperDragEnd() {
    console.log('drag stopped');
    this.isDraggingCropper = false;
    this.saveCrop();
  }

  public currentCropInformationToBeSaved = null;

  public saveCrop() {
    let offsetRatio;
    if (this.cropperMovesInXAxis) {
      offsetRatio = (this.currentCropperX - this.cropperMinX) / this.imageWidth;
    } else {
      offsetRatio =
        (this.currentCropperY - this.cropperMinY) / this.imageHeight;
    }

    this.currentCropInformationToBeSaved = {
      isYAxisTheOneThatIsLocked: this.cropperMovesInXAxis,
      offsetRatio,
      imageAspectRatio: this.imageWidth / this.imageHeight,
      rotationInDegrees: this.totalRotationDegree % 360,
    };
  }

  @ViewChild('cropper')
  public cropperRef: ElementRef;

  @ViewChild('imageToBeCropped')
  public imageToBeCroppedRef: ElementRef;

  public set showCropper(value: boolean) {
    this._showCropper = value;
    if (value) {
      this.initCropper();
    }
  }
  public get showCropper() {
    return this._showCropper;
  }
  public _showCropper = false;

  public totalRotationDegree = 0;

  public imageReWidth: 'auto' | number = 'auto';
  public imageReHeight: 'auto' | number = 'auto';
  public addRotateDegree(value: number) {
    this.totalRotationDegree += value;
    this.totalRotationDegree %= 360;
    this.currentCropInformationToBeSaved = {
      ...this.currentCropInformationToBeSaved,
      rotationInDegrees: this.totalRotationDegree % 360,
    };
  }

  private async initCropper() {
    if (!this.convertedImageToShow) {
      return;
    }
    await new Promise((res) => setTimeout(res, 500));
    this.cropperRef.nativeElement.style.left = '0';
    this.cropperRef.nativeElement.style.right = '0';
    
    const imageToBeCroppedElement = this.imageToBeCroppedRef.nativeElement; //document.getElementById('imageToBeCropped');
    this.cropperSquareElement = this.cropperRef.nativeElement; //document.getElementById('cropper');

    if (!imageToBeCroppedElement || !this.cropperSquareElement) {
      console.error(
        'Error element is missing',
        imageToBeCroppedElement,
        this.cropperSquareElement,
      );
      return;
    }

    this.imageWidth = imageToBeCroppedElement.clientWidth;
    this.imageHeight = imageToBeCroppedElement.clientHeight;

    console.log('dimension =>', this.imageHeight, this.imageWidth);

    //if the height is greater the square will fill the image and will only move up or down
    if (this.imageHeight > this.imageWidth) {
      this.cropperMovesInXAxis = false;
    } else {
      this.cropperMovesInXAxis = true;
    }

    const cropperSqaureSize = Math.min(this.imageHeight, this.imageWidth);

    this.cropperMinX = imageToBeCroppedElement.clientLeft;
    this.cropperMaxX =
      imageToBeCroppedElement.clientLeft + this.imageWidth - cropperSqaureSize;

    this.cropperMinY = imageToBeCroppedElement.clientTop;
    this.cropperMaxY =
      imageToBeCroppedElement.clientTop + this.imageHeight - cropperSqaureSize;

    console.log(
      this.cropperMaxX,
      this.cropperMinX,
      this.cropperMaxY,
      this.cropperMinY,
    );

    console.log('setting square size to', cropperSqaureSize);
    this.cropperSquareElement.style.width = cropperSqaureSize + 'px';
    this.cropperSquareElement.style.height = cropperSqaureSize + 'px';

    console.log('square is set');
  }
}
